<script>
import Vendors from "@/components/procurement/Vendors.vue";

export default {
    name: "Procurement",
    components: {Vendors}
}
</script>

<template>
    <div>
        <section class="d-flex align-content-center align-items-center p-3 bg-white mb-3 rounded-sm">
            <div class="request-profile p-3 text-center">
                <img src="https://erp.test/storage/avatars/22.jpeg" class="rounded-circle mb-2 d-block" style="height: 150px">
            </div>
            <div class="px-4 flex-fill">
                <h4 class="font-weight-bold">John Doe</h4>

                <div>
                    <p>
                        Premium designed icons for use in web, iOS, Android, and desktop apps. Support for SVG.
                        Completely open source, MIT licensed and built by
                        Indicate the program/goal the item will be used for
                    </p>

                    <div class="d-flex mb-3 text-muted">
                        <ion-icon name="timer-outline" class="icon"></ion-icon>&nbsp;
                        <div class="mr-4">
                            Created: Feb 8, 2024
                        </div>
                        <div class="mr-4">
                            Expected: March 1 2024
                        </div>
                        <div class="mr-4">
                            <span class="status active">processed</span>
                        </div>
                    </div>

                    <div class="">
                        <button class="btn btn-dark mr-1">Edit Record</button>
                        <button class="btn btn-danger mr-1">Delete</button>

                        <router-link to="/procurements" class="btn btn-light float-right">Go Back</router-link>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <span class="text-muted">USD</span> <br>
                <h1 class="font">970</h1>
            </div>
        </section>

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link active" href="#">Competitive Quotations</a>
            </li>
            <li class="nav-item">
                <a class="nav-link " href="#">Award</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Internal ERP</a>
            </li>
        </ul>
        <div class="bg-white p-3" style="">
            <vendors></vendors>
        </div>
    </div>
</template>

<style scoped>
.nav-tabs {
    border: none;
}

.nav-tabs .nav-link {
    border: none;
    margin-bottom: 0;
}

.icon {
    font-size: 18px;
    vertical-align: -4px;
    color: gray
}
</style>